package com.milta.core.localization.translations.fr

import com.milta.core.localization.SettingsStrings

internal val Settings = SettingsStrings(
    profileSectionTitle = "PROFIL DE L'ORGANISATION",
    profileNameLabel = "Nom de l'organisation",
    languageSectionTitle = "LANGUE DE L'INTERFACE",
    languageSearchPlaceholder = "Rechercher une langue...",
    languageMoreAvailable = "%d autres langues disponibles",
    languageErrorGeneric = "Une erreur est survenue. Veuillez réessayer.",
    subscriptionSectionTitle = "ABONNEMENT",
    subscriptionPlanLabel = "Formule",
    subscriptionBillingLabel = "Facturation",
    subscriptionRenewalLabel = "Prochain renouvellement",
    subscriptionBillingMonthly = "Mensuelle",
    subscriptionBillingAnnual = "Annuelle",
    subscriptionPlanOrganisationLabel = "Organisation (Patron + équipe)",
    subscriptionPriceSuffix = "HTVA / mois",
    subscriptionUnavailable = "Indisponible",
    deleteSectionTitle = "Supprimer l'organisation",
    deleteWarning = "Cette action est permanente et irréversible.",
    deleteDescription = "Les tournées et les preuves de livraison seront supprimées. Les comptes Chauffeurs/Livreurs seront dissociés de l'organisation, mais jamais supprimés.",
    deleteConfirmLabel = "Pour confirmer, saisissez le nom de l'organisation",
    deleteButton = "Supprimer définitivement",
    deleteFinalDialogTitle = "Confirmer la suppression définitive ?",
    deleteFinalDialogMessage = "Cette action ne peut pas être annulée. L'organisation, ses tournées et ses preuves de livraison seront supprimées définitivement.",
    deleteErrorGeneric = "Une erreur est survenue. Veuillez réessayer.",
    legalSectionTitle = "MENTIONS LÉGALES",
    legalTermsLabel = "Conditions d'utilisation",
    legalPrivacyLabel = "Confidentialité & RGPD",
)
